export default "__VITE_ASSET__2c6d1f30__"